import React, {useState} from "react";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";
import CustomInput from "../../components/CustomInput/CustomInput";
import InputLabel from "@material-ui/core/InputLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import $ from "jquery";
import UserSearch from "../../components/UserSearch";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import StateCircle from "../../components/StateCircle";
import {Check} from "@material-ui/icons";
import PaginaCurso from "../../views/Pages/PaginaCurso";
import PaginaFormacao from "../../views/Pages/PaginaFormacao";
import PreencherFeedback from "../../views/Pages/PreencherFeedback";
import PaginaPercurso from "../../views/Pages/PaginaPercurso";
import Datetime from "../../components/DatetimeWrapper";
import SnackbarContent from "../../components/Snackbar/SnackbarContent";

let inscrever_candidato_percurso_educadores = async (classes, row, done) => {
  let aprovar_pe = {
    formando: row.NIN,
    grupo_fluxo: row.grupo_fluxo,
    percurso: null
  };

  let percursos = (await connection.get("percurso/listagem", {ocultar_fechados: true, grupo_fluxo: row.grupo_fluxo})).percursos;

  let Content = () => {
    const [percurso_state, setPercursoState] = useState(aprovar_pe.percurso);

    return <form autoComplete="off" style={{padding: "0 10px"}}>

      <div style={{marginTop: 30}}>
        <h4>Associar Candidato a Percurso de Educadores</h4>
        <p>
          Para associar o candidato a um {row.grupo_fluxo} escolha o percurso e clique em "Aceitar".
        </p>
      </div>
      <CustomInput
        labelText="Candidato"
        disabled
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          defaultValue: row.nome + " - " + row.NIN,
          disabled: true
        }}
      />
      <FormControl fullWidth className={classes.selectFormControl}>
        <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
          Percurso de Educadores
        </InputLabel>
        <Select
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          value={percurso_state}
          onChange={(event) => {
            aprovar_pe.percurso = event.target.value;
            setPercursoState(event.target.value);
          }}
        >
          <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o percurso</MenuItem>
          {percursos.map((percurso) => {
            return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={percurso.id}><StateCircle state={percurso.estado}/> {percurso.designacao} ({percurso.estado.designation})</MenuItem>;
          })}
        </Select>
      </FormControl>
    </form>;
  };

  window.App.openModal(<SweetAlert
    style={{width: 600}}
    onCancel={() => window.App.hideModal()}
    cancelBtnText="Cancelar"
    showCancel
    denyBtnText="Aprovar"
    confirmBtnText={<>
      <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={e => {
        e.stopPropagation()
        if (aprovar_pe.percurso === null) {
          general.error(`Selecione o ${row.grupo_fluxo} a associar`);
          return;
        }
        connection.post("percurso/continuos/participante/inscrever", aprovar_pe, (data) => {
          general.success(`Candidato associado ao ${row.grupo_fluxo}`, "Sucesso!");
          window.App.hideModal();
          done && done();
        });
      }}>Aceitar
      </button>
    </>}
    confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
    cancelBtnCssClass={
      classes.button
    }
  >
    <Content/>
  </SweetAlert>);
}

let solicitar_inscricao_acampamento_pe = async (classes, row, reloadActions) => {
  window.App.openModal(<SweetAlert
    showClose
    style={{width: 700}}
    title={(<h5 style={{fontSize: "1em"}}>Formalizar Inscrição</h5>)}
    onConfirm={async () => {
      await connection.post(`dashboard/formalizar_percurso_educadores`, {grupo_fluxo: row.grupo_fluxo});
      general.success("Solicitação realizada com sucesso");
      window.App.hideModal();
      reloadActions(true);
    }}
    onCancel={() => window.App.hideModal()}
    confirmBtnCssClass={
      classes.button + " " + classes.primary
    }
    cancelBtnCssClass={
      classes.button
    }
    confirmBtnText="Confirmar"
    cancelBtnText="Agora Não"
    showCancel
  >
    <div style={{marginTop: 30}}>
      <h4>Deseja formalizar inscrição em Percurso {row.grupo_fluxo}?</h4>
      <p>
        Clique em "Confirmar" para formalizar a inscrição no Acampamento do {row.grupo_fluxo}.
      </p>
    </div>
  </SweetAlert>);
}

let atribuir_tutor_pe = async (classes, row, done) => {
  let inscricao = {
    utilizador: row.user,
    grupo_fluxo: row.grupo_fluxo,
    tutor: null
  };

  window.App.openModal(<SweetAlert
    title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
      <span className={classes.modalCardTitle}>Associar Tutor</span>
    </div>)}
    onConfirm={() => {
      connection.post("utilizador/pe_atribuir/tutor", inscricao, (data) => {
        general.success(`Tutor atribuído.`, "Sucesso");
        window.App.hideModal();
        done && done();
      });
    }}
    onCancel={() => window.App.hideModal()}
    cancelBtnText="Cancelar"
    showCancel
    confirmBtnText="Atribuir"
    confirmBtnCssClass={
      classes.button + " " + classes.primary + " " + classes.buttonConfirm
    }
    cancelBtnCssClass={
      classes.button
    }
  >
    <form autoComplete="off" className={classes.addForm}>
      <UserSearch
        labelText="NIN do Tutor"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          type: "number",
          min: "0"
        }}
        onFoundUser={(user) => {
          inscricao.tutor = user.NIN;
        }}
      />
    </form>
  </SweetAlert>);
}

let direcionar_para_percurso = async (classes, row, done) => {
  window.App.openModal(<SweetAlert
    style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
    onConfirm={() => window.App.hideModal()}
    onCancel={() => window.App.hideModal()}
    confirmBtnText="Fechar"
    confirmBtnCssClass={
      classes.button + " " + classes.primary + " " + classes.buttonConfirm
    }>
    <PaginaPercurso id_percurso={row.id_percurso}/>
  </SweetAlert>, () => {
    done();
  });
}

let acoes = {
  // Ações do Diretor de Curso
  APROVAR_INSCRICAO_CURSO: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaCurso id_curso={row.id_curso}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Validar inscrições de candidatos em cursos",
    description: "Clique no botão à frente de cada curso para ver os candidatos antes de aprovar"
  },
  SUBMETER_RELATORIO_CURSO: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaCurso id_curso={row.id_curso}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Submeter relatório de curso",
    description: "Cursos a aguardar submissão de relatório"
  },

  // Ações do Diretor de Percurso
  APROVAR_ESTAGIO: {
    callback: direcionar_para_percurso,
    title: "Aprovar estágio dos candidatos do PIF",
    description: "Clique no botão à frente de cada percurso para ver os candidatos antes de aprovar"
  },
  APROVAR_DISCERNIMENTO: {
    callback: direcionar_para_percurso,
    title: "Aprovar discernimento dos candidatos do PIF",
    description: "Clique no botão à frente de cada percurso para ver os candidatos antes de aprovar"
  },
  PFE_DIRETOR_PERCURSO_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_chefe_agrupamento?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes a aguardar validação de objetivos pelo diretor do percurso"
  },
  SUBMETER_RELATORIO_PERCURSO: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/percurso/" + row.id_percurso)
    },
    title: "Submeter relatório de percurso",
    description: "Percursos a aguardar submissão de relatório"
  },
  PFE_REGRESSO_ATIVO_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar validação de objetivos pelo diretor do percurso"
  },
  PGL_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de percurso PGL",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },
  PRA_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de percurso PRA",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },
  PEI_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de Percurso de Educadores I",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },
  PEII_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de Percurso de Educadores II",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },
  PEIII_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de Percurso de Educadores III",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },
  PEIV_DP_APROVAR_PERCURSO_CONCLUIDO: {
    callback: direcionar_para_percurso,
    title: "Aprovar conclusão de Percurso de Educadores IV",
    description: "Clique no botão à frente de cada percurso para ver os dirigentes antes de aprovar"
  },

  // Ações do Chefe de Agrupamento
  AGUARDA_ASSIST_TUT: {
    callback: async (classes, row, done) => {
      let assistente = await connection.get("dashboard/assistente_agrupamento", null, null, null, {disableNotif: true, returnError: true}).catch(e => e.code === 404 ? null : e);

      let inscricao = {
        utilizador: row.user,
        tutor: null,
        assistente: assistente?.NIN,
        data_apresentacao: null
      };

      let Content = () => {
        const [simulacao, setSimulacao] = useState(null);

        const simular = async () => {
          try {
            let resultado = await connection.post("utilizador/atribuir/tutor_assistente?simulacao=1", inscricao, null, null, {disableNotif: true, returnError: true});
            setSimulacao(resultado);
          } catch (e) {
            setSimulacao(e);
          }
        }

        let mensagem = null;
        if (simulacao && !simulacao.success)
          mensagem = simulacao?.message;

        return <form autoComplete="off" className={classes.addForm}>
          {mensagem && <div style={{margin: "10px 0px 30px"}}>
            <SnackbarContent
              message={mensagem}
              color={simulacao.color}
            />
          </div>}
          <UserSearch
            labelText="NIN do Tutor"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              inscricao.tutor = user.NIN;
              simular();
            }}
          />
          <UserSearch
            labelText="NIN do Assistente"
            defaultUser={assistente}
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              inscricao.assistente = user.NIN;
            }}
          />
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data de apresentação no agrupamento
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolher data"}}
              onChange={(value) => {
                inscricao.data_apresentacao = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={false}
            />
          </FormControl>
        </form>
      }

      window.App.openModal(<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Associar Assistente e Tutor</span>
        </div>)}
        onConfirm={() => {
          connection.post("utilizador/atribuir/tutor_assistente", inscricao, (data) => {
            general.success("Tutor e Assistente atribuídos e Inscrição aprovada.", "Sucesso");
            window.App.hideModal();
            done && done();
          });
        }}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Atribuir"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>);
    },
    title: "Atribuir Tutor e Assistente",
    description: "Candidatos a aguardar atribuição de tutor e assistente"
  },
  UPLOAD_PARECER_INICIAL: {
    callback: (classes, row, done) => {
      modalAprovarCandidato(classes, row, "chefe_agrupamento", "inicial", done)
    },
    title: "Submeter parecer inicial por assistente"
  },
  // PARECER DE MATURIDADE CRISTÃ
  UPLOAD_PARECER_FINAL: {
    callback: (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_maturidade_crista?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Submeter parecer final por assistente",
    description: "Consulte abaixo os candidatos a aguardar parecer do assistente para concluir aprovacao ao discernimento"
  },
  AGUARDA_PEDIDO_INVESTIDURA: {
    callback: (classes, row, done) => {
      window.App.hist.push("/formulario/pedido_investidura_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Realizar pedido de investidura",
    description: "Dirigentes a aguardar pedido de investidura"
  },
  AGUARDA_ASSISTENTE: {
    callback: async (classes, row, done) => {
      let assistente = await connection.get("dashboard/assistente_agrupamento", null, null, null, {disableNotif: true, returnError: true}).catch(e => e.code === 404 ? null : e);

      let inscricao = {
        utilizador: row.user,
        assistente: assistente?.NIN,
        data_apresentacao: null
      };

      window.App.openModal(<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Associar Assistente</span>
        </div>)}
        onConfirm={() => {
          connection.post("utilizador/atribuir/assistente", inscricao, (data) => {
            general.success("Assistente atribuído.", "Sucesso");
            window.App.hideModal();
            done && done();
          });
        }}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Atribuir"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Assistente"
            defaultUser={assistente}
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              inscricao.assistente = user.NIN;
            }}
          />
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data de apresentação no agrupamento
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolher data"}}
              onChange={(value) => {
                inscricao.data_apresentacao = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={false}
            />
          </FormControl>
        </form>
      </SweetAlert>);
    },
    title: "Atribuir Assistente para o Percurso de Regresso ao Ativo",
    description: "Dirigentes no PRA a aguardar atribuição de assistente"
  },
  PEI_AGUARDA_TUTOR: {
    callback: async (classes, row, done) => {
      await atribuir_tutor_pe(classes, row, done);
    },
    title: "Atribuir Tutor PEI",
    description: "Candidatos a aguardar atribuição de tutor"
  },
  PEII_AGUARDA_TUTOR: {
    callback: async (classes, row, done) => {
      await atribuir_tutor_pe(classes, row, done);
    },
    title: "Atribuir Tutor PEII",
    description: "Candidatos a aguardar atribuição de tutor"
  },
  PEIII_AGUARDA_TUTOR: {
    callback: async (classes, row, done) => {
      await atribuir_tutor_pe(classes, row, done);
    },
    title: "Atribuir Tutor PEIII",
    description: "Candidatos a aguardar atribuição de tutor"
  },
  PEIV_AGUARDA_TUTOR: {
    callback: async (classes, row, done) => {
      await atribuir_tutor_pe(classes, row, done);
    },
    title: "Atribuir Tutor PEIV",
    description: "Candidatos a aguardar atribuição de tutor"
  },

  // Ações do Tutor
  PDPE_OBJETIVOS_VALIDAR_PRELIMINAR: {
    callback: async (classes, row) => {
      window.App.hist.push("/formulario/pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PDPE dos Candidatos",
    description: "Candidato a aguardar validação de objetivos pelo tutor"
  },
  PARECER_PDPE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Submeter parecer de PDPE dos Candidatos",
    description: "Candidato a aguardar envio de parecer pelo tutor"
  },
  PDPE_OBJETIVOS_REVALIDAR_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PDPE dos Candidatos",
    description: "Candidato a aguardar revalidação de objetivos pelo tutor"
  },
  PFE_OBJETIVOS_VALIDAR_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Candidatos",
    description: "Candidato a aguardar validação de objetivos pelo tutor"
  },
  PARECER_PFE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Submeter parecer de PFE dos Candidatos",
    description: "Candidato a aguardar envio de parecer pelo tutor"
  },
  PFE_OBJETIVOS_REVALIDAR_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PFE dos Candidatos",
    description: "Candidato a aguardar revalidação de objetivos pelo tutor"
  },

  PFE_PEI_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=pei");
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEI a aguardar validação de objetivos pelo tutor"
  },
  PFE_PEII_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peii");
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEII a aguardar validação de objetivos pelo tutor"
  },
  PFE_PEIII_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiii");
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEIII a aguardar validação de objetivos pelo tutor"
  },
  PFE_PEIV_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiv");
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEIV a aguardar validação de objetivos pelo tutor"
  },
  PEI_PARECER_PFE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=pei");
    },
    title: "Submeter parecer de PFE no Percurso de Educadores I",
    description: "Dirigentes no PEI a aguardar envio de parecer pelo tutor"
  },
  PEI_PFE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=pei");
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEI a aguardar revalidação de objetivos pelo tutor"
  },
  PEII_PARECER_PFE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peii");
    },
    title: "Submeter parecer de PFE no Percurso de Educadores II",
    description: "Dirigentes no PEII a aguardar envio de parecer pelo tutor"
  },
  PEII_PFE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peii");
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEII a aguardar revalidação de objetivos pelo tutor"
  },
  PEIII_PARECER_PFE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiii");
    },
    title: "Submeter parecer de PFE no Percurso de Educadores III",
    description: "Dirigentes no PEIII a aguardar envio de parecer pelo tutor"
  },
  PEIII_PFE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiii");
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEIII a aguardar revalidação de objetivos pelo tutor"
  },
  PEIV_PARECER_PFE_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiv");
    },
    title: "Submeter parecer de PFE no Percurso de Educadores IV",
    description: "Dirigentes no PEIV a aguardar envio de parecer pelo tutor"
  },
  PEIV_PFE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiiv");
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PEIV a aguardar revalidação de objetivos pelo tutor"
  },
  PFE_CURSO_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/ver?submissao=" + row.id_submissao + "&utilizador=" + row.utilizador);
    },
    title: "Validar objetivos do PFE de Formadores",
    description: "Formulários de objetivos PFE, a aguardar validação pelo tutor"
  },
  PFE_CURSO_PARECER: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/ver?submissao=" + row.id_submissao + "&utilizador=" + row.utilizador);
    },
    title: "Submeter parecer PFE de Formadores",
    description: "Formulários de parecer PFE de formadores, a aguardar parecer do tutor"
  },

  // Ações do Tutor Regional
  PFE_REGRESSO_ATIVO_OBJETIVOS_VALIDAR_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar validação de objetivos pelo tutor"
  },
  PARECER_PFE_REGRESSO_ATIVO_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Submeter parecer de PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar envio de parecer pelo tutor"
  },
  PFE_REGRESSO_ATIVO_OBJETIVOS_REVALIDAR_PRELIMINAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar revalidação de objetivos pelo tutor"
  },

  // Ações do Tutor de Núcleo
  PDPE_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PDPE dos Candidatos",
    description: "Candidato a aguardar validação de objetivos pelo tutor de núcleo"
  },
  PARECER_PDPE: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar parecer de PDPE dos Candidatos",
    description: "Candidato a aguardar validação de parecer pelo tutor de núcleo"
  },
  PDPE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pdpe?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PDPE dos Candidatos",
    description: "Candidato a aguardar revalidação de objetivos pelo tutor de núcleo"
  },
  PARECER_MATURIDADE_CRISTA: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_maturidade_crista?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Aprovar parecer de Maturidade Cristã dos Candidatos",
    description: "Candidato a aguardar aprovação de parecer pelo tutor de núcleo"
  },
  PRA_TN_PARECER_MATURIDADE_CRISTA: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_mc_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Aprovar parecer de Maturidade Cristã dos Dirigentes",
    description: "Dirigentes a aguardar aprovação de parecer pelo tutor de núcleo"
  },
  PFE_OBJETIVOS_VALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Candidatos",
    description: "Candidato a aguardar validação de objetivos pelo tutor de núcleo"
  },
  PARECER_PFE: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar parecer de PFE dos Candidatos",
    description: "Candidato a aguardar validação de parecer pelo tutor de núcleo"
  },
  PFE_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PFE dos Candidatos",
    description: "Candidato a aguardar revalidação de objetivos pelo tutor de núcleo"
  },
  PEDIDO_INVESTIDURA_VALIDAR_PRELIMINAR: {
    callback: (classes, row, done) => {
      window.App.hist.push("/formulario/pedido_investidura_dirigente?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar pedido de investidura",
    description: "Consulte abaixo os candidatos a aguardar validação de pedido de investidura."
  },
  PFE_REGRESSO_ATIVO_OBJETIVOS: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Validar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar validação de objetivos pelo tutor de núcleo"
  },
  PARECER_PFE_REGRESSO_ATIVO: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Submeter parecer de PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar envio de parecer pelo tutor de núcleo"
  },
  PFE_REGRESSO_ATIVO_OBJETIVOS_REVALIDAR: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/pfe_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    title: "Revalidar objetivos do PFE dos Dirigentes",
    description: "Dirigentes no PRA a aguardar revalidação de objetivos pelo tutor de núcleo"
  },
  PEI_PARECER_PFE_EDUCADORES: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=pei");
    },
    title: "Submeter parecer de PFE dos Dirigentes no Percurso de Educadores I",
    description: "Dirigentes no PEI a aguardar envio de parecer pelo tutor de núcleo"
  },
  PEII_PARECER_PFE_EDUCADORES: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peii");
    },
    title: "Submeter parecer de PFE dos Dirigentes no Percurso de Educadores II",
    description: "Dirigentes no PEII a aguardar envio de parecer pelo tutor de núcleo"
  },
  PEIII_PARECER_PFE_EDUCADORES: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiii");
    },
    title: "Submeter parecer de PFE dos Dirigentes no Percurso de Educadores III",
    description: "Dirigentes no PEIII a aguardar envio de parecer pelo tutor de núcleo"
  },
  PEIV_PARECER_PFE_EDUCADORES: {
    callback: async (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_pfe_educadores?utilizador=" + row.user + "&grupo_fluxo=peiv");
    },
    title: "Submeter parecer de PFE dos Dirigentes no Percurso de Educadores IV",
    description: "Dirigentes no PEIV a aguardar envio de parecer pelo tutor de núcleo"
  },

  // Ações do Assistente
  APROVACAO_INICIAL: {
    callback: (classes, row, done) => {
      modalAprovarCandidato(classes, row, "assistente", "inicial", done)
    },
    button: "Submeter parecer",
    title: "Candidatos a aguardar pareceres do assistente",
    description: "Consulte abaixo os candidatos a aguardar parecer.",
    //row.value.momento === 'inicial' ? 'Parecer inicial' : 'Parecer de maturidade cristã'
  },
  // PARECER DE MATURIDADE CRISTÃ - PIF
  APROVACAO_FINAL: {
    callback: (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_maturidade_crista?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    button: "Submeter parecer",
    title: "Candidatos a aguardar pareceres do assistente",
    description: "Consulte abaixo os candidatos a aguardar parecer."
  },
  // PARECER DE MATURIDADE CRISTÃ -PRA
  PRA_PARECER_MATURIDADE_CRISTA: {
    callback: (classes, row, done) => {
      window.App.hist.push("/formulario/parecer_mc_regresso_ativo?utilizador=" + row.user + "&id_percurso=" + row.percurso);
    },
    button: "Submeter parecer",
    title: "Dirigentes a aguardar pareceres do assistente",
    description: "Consulte abaixo os dirigentes no PRA a aguardar parecer."
  },

  // Ações do Administrador
  APROVAR_CURSOS: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaCurso id_curso={row.id_curso}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Aprovar publicação de cursos",
    description: "Clique no botão à frente de cada curso para ver os seus detalhes antes de aprovar"
  },
  APROVAR_PERCURSOS: {
    callback: direcionar_para_percurso,
    title: "Aprovar publicação de percursos",
    description: "Clique no botão à frente de cada percurso para ver os seus detalhes antes de aprovar"
  },
  ADM_APROVAR_RELATORIO_CURSO: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaCurso id_curso={row.id_curso}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Aprovar relatórios de curso",
    description: "Clique no botão à frente de cada curso para ver o relatório e aprovar/rejeitar"
  },

  // Ações do Secretário Regional
  APROVAR_FORMACOES: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaFormacao id_formacao={row.id_formacao}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Aprovar publicação de módulos",
    description: "Clique no botão à frente de cada módulo para ver os seus detalhes antes de aprovar"
  },
  AGUARDA_PRA: {
    callback: async (classes, row, done) => {
      let aprovar_pra = {
        formando: row.NIN,
        grupo_fluxo: 'PRA',
        tutor: null,
        percurso: null,
        codigo_modelo: null
      };

      let percursos = (await connection.get("percurso/listagem", {ocultar_fechados: true, grupo_fluxo: 'PRA', apenas_disponiveis: true})).percursos;
      let modelos = await connection.get("modelo/listagem", {tipo: '_PRA'});

      let Content = () => {
        const [percurso_state, setPercursoState] = useState(aprovar_pra.percurso);
        const [codigo_modelo_state, setCodigoModeloState] = useState(aprovar_pra.codigo_modelo);

        return <form autoComplete="off" style={{padding: "0 10px"}}>
          <div style={{marginTop: 30}}>
            <h4>Associar Candidato a Percurso de Regresso ao Ativo</h4>
            <p>
              Para associar o candidato a um PRA escolha o percurso e clique em "Aprovar".
              {/*Caso o parecer não esteja correto poderá rejeitar o pedido. O chefe de agrupamento terá de voltar a submeter o parecer.*/}
            </p>
          </div>
          <CustomInput
            labelText="Candidato"
            disabled
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              defaultValue: row.nome + " - " + row.NIN,
              disabled: true
            }}
          />
          <UserSearch
            labelText="NIN do Tutor"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              aprovar_pra.tutor = user.NIN;
            }}
          />
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
              Percurso de Regresso ao Ativo
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={percurso_state}
              onChange={(event) => {
                aprovar_pra.percurso = event.target.value;
                setPercursoState(event.target.value);
              }}
            >
              <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o percurso</MenuItem>
              {percursos.map((percurso) => {
                return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={percurso.id}><StateCircle state={percurso.estado}/> {percurso.designacao} ({percurso.estado.designation})</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
              Tempo Inativo
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={codigo_modelo_state}
              onChange={(event) => {
                aprovar_pra.codigo_modelo = event.target.value;
                setCodigoModeloState(event.target.value);
              }}
            >
              <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o tempo de inatividade</MenuItem>
              {modelos.map((modelo) => {
                return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modelo.codigo_modelo}>{modelo.codigo_modelo === 'PRA2' ? 'De 2 a 5 anos' : 'Mais de 5 anos'}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </form>;
      };

      window.App.openModal(<SweetAlert
        style={{width: 600}}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        denyBtnText="Aprovar"
        confirmBtnText={<>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={e => {
            e.stopPropagation()
            if (aprovar_pra.percurso === null) {
              general.error("Selecione o PRA a associar");
              return;
            }
            connection.post("percurso/participante/inscrever", aprovar_pra, (data) => {
              general.success("Candidato associado ao PRA", "Sucesso!");
              window.App.hideModal();
              done && done();
            });
          }}>Aprovar
          </button>
        </>}
        confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>);
    },
    title: "Colocar candidatos interessados no PRA"
  },

  AGUARDA_PIF: {
    callback: async (classes, row, done) => {
      let aprovar_pif = {
        formando: row.NIN,
        grupo_fluxo: 'PIF',
        percurso: null
      };

      let percursos = (await connection.get("percurso/listagem", {ocultar_fechados: true, grupo_fluxo: 'PIF'})).percursos;
      let percurso_utilizador = await connection.get("utilizador/percurso/pif", {id_utilizador: row.user});
      let parecer_registado = percurso_utilizador.PARECER_REGISTADO;

      let ficheiro_anexo = (await connection.get(`forms/anexos/${parecer_registado?.extra?.id_resposta}`))[0];

      let Content = () => {
        const [percurso_state, setPercursoState] = useState(aprovar_pif.percurso);

        return <form autoComplete="off" style={{padding: "0 10px"}}>
          {ficheiro_anexo && <div>
            <h4>Parecer submetido pelo chefe de agrupamento</h4>
            {ficheiro_anexo.informacoes_ficheiro.mimetype.substr(0, 5) === 'image' ? <img width="100%" src={connection.getFullUrl(ficheiro_anexo.path)}/> :
              <div style={{height: "calc(100vh - 500px)", minHeight: 300, position: "relative"}}>
                <iframe width="100%" style={{border: 0, position: "absolute", top: 0, bottom: 0, left: 0, right: 0, height: "100%"}} src={connection.getFullUrl(ficheiro_anexo.path) + "#navpanes=0"}/>
              </div>}
          </div>}
          <div style={{marginTop: 30}}>
            <h4>Associar Candidato a Percurso Inicial de Formação</h4>
            <p>
              Para associar o candidato a um PIF escolha o percurso e clique em "Aprovar".
              {/*Caso o parecer não esteja correto poderá rejeitar o pedido. O chefe de agrupamento terá de voltar a submeter o parecer.*/}
            </p>
          </div>
          <CustomInput
            labelText="Candidato"
            disabled
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              defaultValue: row.nome + " - " + row.NIN,
              disabled: true
            }}
          />
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
              Percurso Inicial de Formação
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={percurso_state}
              onChange={(event) => {
                aprovar_pif.percurso = event.target.value;
                setPercursoState(event.target.value);
              }}
            >
              <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o percurso</MenuItem>
              {percursos.map((percurso) => {
                return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={percurso.id}><StateCircle state={percurso.estado}/> {percurso.designacao} ({percurso.estado.designation})</MenuItem>;
              })}
            </Select>
          </FormControl>
        </form>;
      };

      window.App.openModal(<SweetAlert
        style={{width: 600}}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showClose
        denyBtnText="Aprovar"
        confirmBtnText={<>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.danger + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async e => {
            e.stopPropagation();
            let observacoes = await window.App.confirm(classes, "Rejeitar parecer", "Indique as observações da rejeição do parecer de " + row.nome + " - " + row.NIN, {prompt: true});
            connection.post("dashboard/rejeitar_parecer", {id_utilizador: row.user, observacoes}, (data) => {
              general.success("Parecer Rejeitado");
              window.App.hideModal();
              done && done();
            });
          }}>Rejeitar
          </button>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={e => {
            e.stopPropagation()
            if (aprovar_pif.percurso === null) {
              general.error("Selecione o PIF a associar");
              return;
            }
            connection.post("percurso/participante/inscrever", aprovar_pif, (data) => {
              general.success("Candidato associado ao PIF", "Sucesso!");
              window.App.hideModal();
              done && done();
            });
          }}>Aprovar
          </button>
        </>}
        confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
      >
        <Content/>
      </SweetAlert>);
    },
    title: "Colocar candidatos interessados no PIF"
  },
  SR_APROVAR_RELATORIO_CURSO: {
    callback: async (classes, row, done) => {
      window.App.openModal(<SweetAlert
        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
        onConfirm={() => window.App.hideModal()}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Fechar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }>
        <PaginaCurso id_curso={row.id_curso}/>
      </SweetAlert>, () => {
        done();
      });
    },
    title: "Aprovar relatórios de cursos regionais",
    description: "Clique no botão à frente de cada curso para ver o relatório e aprovar/rejeitar"
  },
  APROVAR_RELATORIO_PERCURSO: {
    callback: direcionar_para_percurso,
    title: "Aprovar relatórios de percurso",
    description: "Clique no botão à frente de cada percurso para ver o relatório e aprovar/rejeitar"
  },
  PEDIDO_INVESTIDURA_VALIDAR: {
    callback: (classes, row, done) => {
      window.App.hist.push("/investiduras");
    },
    title: "Validar pedido de investidura",
    description: "Clique no botão à frente para visualizar a listagem dos Pedidos de Investidura."
  },
  SR_AGUARDA_PEI: {
    callback: async (classes, row, done) => {
      await inscrever_candidato_percurso_educadores(classes, row, done);
    },
    title: "Colocar candidatos interessados no Percurso de Educadores I"
  },
  SR_AGUARDA_PEII: {
    callback: async (classes, row, done) => {
      await inscrever_candidato_percurso_educadores(classes, row, done);
    },
    title: "Colocar candidatos interessados no Percurso de Educadores II"
  },
  SR_AGUARDA_PEIII: {
    callback: async (classes, row, done) => {
      await inscrever_candidato_percurso_educadores(classes, row, done);
    },
    title: "Colocar candidatos interessados no Percurso de Educadores III"
  },
  SR_AGUARDA_PEIV: {
    callback: async (classes, row, done) => {
      await inscrever_candidato_percurso_educadores(classes, row, done);
    },
    title: "Colocar candidatos interessados no Percurso de Educadores IV"
  },
  SR_ATRIBUIR_TUTOR_CURSO: {
    callback: async (classes, row, done) => {
      let nin_tutor = null;

      const AtribuirTutorForm = () => {
        const [tutorSelecionado, setTutorSelecionado] = useState(null);

        nin_tutor = tutorSelecionado ? tutorSelecionado.NIN : null;

        return (
          <div>
            <p style={{marginBottom: "8px"}}>
              Indique o NIN do tutor a atribuir a <span style={{whiteSpace: "nowrap"}}>{row.nome}</span>.
            </p>
            <UserSearch
              labelText="NIN do Tutor"
              formControlProps={{fullWidth: true}}
              inputProps={{type: "number", min: "0"}}
              onFoundUser={(user) => {
                nin_tutor = user.NIN;
                setTutorSelecionado(user);
              }}
              onUserNotFound={() => {
                nin_tutor = null;
                setTutorSelecionado(null);
              }}
            />
          </div>
        );
      };

      window.App.openModal(<SweetAlert
        style={{width: 480}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Atribuir Tutor</span>
        </div>)}
        onConfirm={() => {
          if (!nin_tutor)
            return general.error("Por favor selecione um tutor válido.");
          window.App.hideModal();
          connection.post("curso/participante/atribuir_tutor", {
            curso: row.curso,
            candidato: row.utilizador,
            nin_tutor: String(nin_tutor)
          }, () => {
            general.success("Tutor atribuído com sucesso.", "Sucesso");
            done();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <AtribuirTutorForm/>
      </SweetAlert>);
    },
    title: "Atribuir tutor a participantes de cursos",
    description: "Participantes de cursos na sua região que aguardam atribuição de tutor."
  },

  // Ações do Formando
  PREENCHER_FORMULARIO: {
    callback: async (classes, row, done) => {
      let url = `/formulario/${row.etiqueta}?utilizador=`;

      if (['PEI', 'PEII', 'PEIII', 'PEIV'].includes(row.grupo_fluxo))
        url += "&grupo_fluxo=" + row.grupo_fluxo;
      else
        url += "&id_percurso=" + row.id_percurso;

      window.App.hist.push(url);
    },
    title: "Preencher Formulário",
    description: "Tem formulário pendente de preenchimento:"
  },
  FEEDBACK_MODULO: {
    callback: async (classes, row, done) => {
      window.App.openModal(
        <SweetAlert
          style={{
            width: 750, padding: 40
          }}
          title="Feedback do Módulo"
          showCancel={false}
          showConfirm={false}
          onConfirm={() => {
          }}
          onCancel={() => window.App.hideModal()}
          showClose
        >
          <p style={{textAlign: "center"}}><strong>{row.designation}</strong></p>
          <PreencherFeedback formacaoId={row.id_formacao} modalidade={row.modalidade} onFeedbackGiven={() => {
            done();
            window.App.hideModal();
          }}/>
        </SweetAlert>, () => {
          done();
        });
    },
    title: "Submeter Feedback",
    description: "Tem feedback pendente para os seguintes módulos:"
  },
  FORMALIZAR_PIF: {
    callback: (classes, row, reloadActions) => {
      window.App.openModal(<SweetAlert
        showClose
        style={{width: 700}}
        title={(<h5 style={{fontSize: "1em"}}>Formalizar Inscrição</h5>)}
        onConfirm={async () => {
          await connection.post("dashboard/participar_percurso/PIF");
          general.success("Incrição no PIF realizada com sucesso");
          window.App.hideModal();
          reloadActions(true);
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Agora Não"
        showCancel
      >
        Clique em "Confirmar" para formalizar a inscrição no Percurso Inicial de Formação.
      </SweetAlert>);
    },
    title: "Percurso Inicial de Formação"
  },
  FORMALIZAR_PRA: {
    callback: (classes, row, reloadActions) => {
      window.App.openModal(<SweetAlert
        showClose
        style={{width: 700}}
        title={(<h5 style={{fontSize: "1em"}}>Formalizar Inscrição</h5>)}
        onConfirm={async () => {
          await connection.post("dashboard/participar_percurso/PRA");
          general.success("Incrição no PRA realizada com sucesso");
          window.App.hideModal();
          reloadActions(true);
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Agora Não"
        showCancel
      >
        Clique em "Confirmar" para formalizar a inscrição no Percurso de Regresso ao Ativo.
      </SweetAlert>);
    },
    title: "Percurso de Regresso ao Ativo"
  },

  FORMALIZAR_PE: {
    callback: async (classes, row, reloadActions) => {
      let participar_pe = {
        grupo_fluxo: 'PE',
        percurso: null
      };

      let percurso_escolhido = null;
      let percursos_de_educadores = await connection.get("percurso/listagem_tipos", {apenas_percurso_educadores: true});

      let Content = () => {
        const [percurso_state, setPercursoState] = useState(participar_pe.percurso);

        return <form autoComplete="off" style={{padding: "0 10px"}}>
          <div style={{marginTop: 30}}>
            <h4>Em qual Percurso de Educadores deseja solicitar inscrição?</h4>
            <p>
              Escolha um dos percursos abaixo e clique em "Confirmar" para formalizar a intenção de participar no Percurso de Educadores.
            </p>
          </div>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
              Percurso de Educadores
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={percurso_state}
              onChange={(event) => {
                percurso_escolhido = event.target.value;
                setPercursoState(event.target.value);
              }}
            >
              <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o percurso de educadores</MenuItem>
              {percursos_de_educadores.map((percurso) => {
                return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={percurso.codigo}>{percurso.designacao}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </form>;
      };

      window.App.openModal(<SweetAlert
        showClose
        style={{width: 700}}
        title={(<h5 style={{fontSize: "1em"}}>Formalizar Intenção de Participação</h5>)}
        onConfirm={async () => {
          await connection.post(`dashboard/participar_percurso/${percurso_escolhido}`);
          general.success("Intenção de participação em PE realizada com sucesso");
          window.App.hideModal();
          reloadActions(true);
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Agora Não"
        showCancel
      >
        <Content/>
      </SweetAlert>);
    },
    title: "Percurso de Educadores"
  },

  INSCREVER_ACAMPAMENTO_PEI: {
    callback: async (classes, row, reloadActions) => {
      await solicitar_inscricao_acampamento_pe(classes, row, reloadActions)
    },
    title: "Solicitar Inscrição no Acampamento do Percurso de Educadores I"
  },

  INSCREVER_ACAMPAMENTO_PEII: {
    callback: async (classes, row, reloadActions) => {
      await solicitar_inscricao_acampamento_pe(classes, row, reloadActions)
    },
    title: "Solicitar Inscrição no Acampamento do Percurso de Educadores II"
  },

  INSCREVER_ACAMPAMENTO_PEIII: {
    callback: async (classes, row, reloadActions) => {
      await solicitar_inscricao_acampamento_pe(classes, row, reloadActions)
    },
    title: "Solicitar Inscrição no Acampamento do Percurso de Educadores III"
  },

  INSCREVER_ACAMPAMENTO_PEIV: {
    callback: async (classes, row, reloadActions) => {
      await solicitar_inscricao_acampamento_pe(classes, row, reloadActions)
    },
    title: "Solicitar Inscrição no Acampamento do Percurso de Educadores IV"
  },

  VALIDAR_INSCRICAO_PGL: {
    callback: (classes, row, reloadActions) => {
      window.App.openModal(<SweetAlert
        showCancel
        showConfirm
        showClose
        style={{width: 500}}
        title={(<h5 style={{fontSize: "1em"}}>Validar Inscrição</h5>)}
        onConfirm={async () => {
          await connection.post("percurso/continuos/participante/aprovar_inscricao", {id_percurso: row.percurso, id_dirigente: row.user});
          general.success("Inscrição validada com sucesso");
          window.App.hideModal();
          reloadActions(true);
        }}
        onCancel={() => window.App.openModal(<SweetAlert
          showCancel
          showConfirm
          style={{width: 400}}
          title={(<h5 style={{fontSize: "1em"}}>Rejeitar Inscrição</h5>)}
          onConfirm={async () => {
            connection.post("percurso/continuos/participante/cancelar_participacao", {
              percurso: row.percurso,
              formando: row.user
            }, () => {
              general.success("Registo anulado com sucesso.", "Sucesso");
              //finished && finished();
            });
            window.App.hideModal();
            reloadActions(true);
          }}
          onCancel={() => window.App.hideModal()}
          confirmBtnCssClass={
            classes.button + " " + classes.primary
          }
          cancelBtnCssClass={
            classes.button
          }
          confirmBtnText="Confirmar"
          cancelBtnText="Cancelar"
        >
          Clique em "Confirmar" para rejeitar a inscrição do dirigente {row.nome} no Percurso {row.percurso_designacao}.
        </SweetAlert>)
        }
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button + " " + classes.danger
        }
        confirmBtnText="Aprovar"
        cancelBtnText="Rejeitar"
      >
        Clique em "Aprovar" para validar a inscrição do dirigente {row.nome} no Percurso {row.percurso_designacao}.
      </SweetAlert>);
    },
    title: "Validar inscrições em percursos de formação contínua",
    description: "Dirigentes a aguardar validação de inscrição"
  },

  SR_AGUARDA_VAL_INVESTIDURA: {
    callback: async (classes, row, done) => {
      let Content = () => {
        return <form autoComplete="off" style={{padding: "0 10px"}}>
          <div style={{marginTop: 30}}>
            <h3>Confirmar realização de investidura</h3>
            <p>
              Para confirmar que a investidura do candidato(a) <strong>{row.nome} ({row.NIN})</strong> foi realizada clique em "Aprovar".
            </p>
            <p>
              Caso a investidura não se tenha realizado, poderá rejeitar esta tarefa. Será necessário que o chefe de agrupamento volte a realizar um pedido de investidura.
            </p>
          </div>
        </form>;
      };

      window.App.openModal(<SweetAlert
        style={{width: 600}}
        showClose
        onClose={() => window.App.hideModal()}
        confirmBtnCssClass={classes.button + " " + classes.primary}
        confirmBtnText={"Aprovar"}
        onConfirm={() => {
          connection.post("percurso/pif/investidura/validar", {
            formando: row.user
          }, (data) => {
            general.success("Investidura validada", "Sucesso!");
            window.App.hideModal();
            done && done();
          });
        }}
        showCancel
        cancelBtnCssClass={classes.button + " " + classes.danger}
        cancelBtnText="Rejeitar"
        onCancel={() => window.App.openModal(<SweetAlert
          showCancel
          showConfirm
          style={{width: 400}}
          title={(<h5 style={{fontSize: "1em"}}>Investidura não realizada</h5>)}
          onConfirm={async () => {
            await connection.post("percurso/pif/investidura/rejeitar", {
              percurso: row.percurso,
              formando: row.user
            }, () => {
              general.success("Registo anulado com sucesso.", "Sucesso");
              //finished && finished();
            });
            window.App.hideModal();
            done && done(true);
          }}
          onCancel={() => window.App.hideModal()}
          confirmBtnCssClass={
            classes.button + " " + classes.primary
          }
          cancelBtnCssClass={
            classes.button
          }
          confirmBtnText="Confirmar"
          cancelBtnText="Cancelar"
        >
          Clique em "Confirmar" para invalidar a data de investidura do(a) candidato(a) <strong>{row.nome}</strong>.
        </SweetAlert>)
        }
      >
        <Content/>
      </SweetAlert>);
    },
    title: "Confirmar investiduras de candidatos"
  },
};

function modalAprovarCandidato(classes, user, tipo, momento, done) {
  let aprov = {
    user_id: user.user,
    aprov: false,
    ficheiro: null,
    tipo: tipo,
    momento: momento
  };

  let id = parseInt(Math.random() * 10000, 10);

  window.App.openModal(<SweetAlert
    style={{width: 700}}
    title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
      <span className={classes.modalCardTitle}>Submeter parecer</span>
    </div>)}
    onConfirm={() => {
      let form_data = new FormData();
      form_data.append("user_id", aprov.user_id);
      form_data.append("aprov", aprov.aprov ? 1 : 0);
      form_data.append("momento", aprov.momento);

      if (aprov.ficheiro)
        form_data.append("ficheiro", aprov.ficheiro);

      connection.post("dashboard/submeter_parecer", form_data, (data) => {
        general.success("Candidato Aprovado", "Sucesso");
        window.App.hideModal();
        done && done();
      });
    }}
    onCancel={() => window.App.hideModal()}
    cancelBtnText="Cancelar"
    showCancel
    confirmBtnText="Aprovar"
    confirmBtnCssClass={
      classes.button + " " + classes.primary + " " + classes.buttonConfirm
    }
    cancelBtnCssClass={
      classes.button
    }
  >
    {tipo === "chefe_agrupamento" ? (
        <p style={{textAlign: "justify", marginTop: 10}}>Para que o(a)
          candidato(a) <strong>{user.nome} (NIN: {user.NIN})</strong> possa continuar com o processo de formação, é
          necessário que o seu assistente aprove a continuidade. <br/><br/> <strong>Como chefe de agrupamento, por
            favor anexe uma digitalização do parecer positivo do assistente e assinale a caixa de confirmação
            abaixo.</strong>
        </p>
      ) :
      <p style={{textAlign: "justify", marginTop: 10}}>Para que o(a)
        candidato(a) <strong>{user.nome} (NIN: {user.NIN})</strong> possa continuar com o processo de formação, é
        necessária a sua aprovação. <br/><br/> <strong>Como assistente, confirme a aptidão do candidato assinalando
          a caixa de confirmação abaixo.</strong>
      </p>
    }
    <form autoComplete="off" className={classes.addForm} style={{marginTop: 10}}>
      <FormControlLabel
        control={
          <Checkbox
            tabIndex={-1}
            onClick={() => aprov.aprov = !aprov.aprov}
            checkedIcon={<Check className={classes.checkedIcon}/>}
            icon={<Check className={classes.uncheckedIcon}/>}
            classes={{
              checked: classes.checked
            }}
          />
        }
        classes={{
          label: classes.label
        }}
        label={tipo === "chefe_agrupamento" ? ("Certifico que o assistente aprovou o(a) candidato(a) " + user.nome + " (NIN: " + user.NIN + ") e que este pode prosseguir com o processo de formação.") : "Certifico que este candidato está apto para prosseguir com o processo de formação."}
      />
      {tipo === "chefe_agrupamento" ? (

        <div style={{textAlign: "center", marginTop: "10px"}}>
          <label htmlFor={"raised-button-file-" + id}>
            <input
              accept=".pdf, .docx, .doc, .png, .jpg, .jpeg"
              className={classes.input}
              id={"raised-button-file-" + id}
              type="file"
              onChange={(e) => {
                if (e.target.files.length > 0) {
                  aprov.ficheiro = e.target.files[0];
                  $("#file-upload-name-" + id).text(e.target.files[0].name);
                }
              }}
            />
            <p id={"file-upload-name-" + id}></p>
          </label>
        </div>) : null}
    </form>
  </SweetAlert>);
}

export default acoes;